import { render, staticRenderFns } from "./ieltsTest.vue?vue&type=template&id=772d63c3&scoped=true&"
import script from "./ieltsTest.vue?vue&type=script&lang=js&"
export * from "./ieltsTest.vue?vue&type=script&lang=js&"
import style0 from "./ieltsTest.vue?vue&type=style&index=0&id=772d63c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d63c3",
  null
  
)

export default component.exports